import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1f251847"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=1f251847&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./list.vue?vue&type=custom&index=0&blockType=graphql"
if (typeof block0 === 'function') block0(component)

export default component.exports